// Спойлер Вопросы и ответы
$('.show').prev().addClass('open');
$('.questions').on('show.bs.collapse', function (e) {
    $(e.target).prev('.btn-collapse').addClass('open');
}).on('hide.bs.collapse', function (e) {
    $(e.target).prev('.btn-collapse').removeClass('open');
});
